export default __webpack_public_path__ + "static/media/361.0d142859.png";